/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "969a7da703f15fc9bc757b7fe80678ec29e05b4d";
